module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert W. Wall, Richard B. Steele\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Robert W. Wall")]), _vm._v(" is Paul T. Walls Professor Emeritus of Scripture and Wesleyan Studies at Seattle Pacific University, where he taught for forty-three years until his retirement in 2021. He has authored numerous books and commentaries on the New Testament. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17AXzFU/tc-custom/9781467437639.jpg?1730488364083",
      "alt": "This image is the cover for the book 1 and 2 Timothy and Titus, Two Horizons New Testament Commentary (THNTC)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("1 and 2 Timothy and Titus, Two Horizons New Testament Commentary (THNTC)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This theological commentary on 1 & 2 Timothy and Titus by Robert Wall powerfully demonstrates the ongoing relevance and authority of the Pastoral Epistles for the church today. Wall uniquely employs an apostolic \"Rule of Faith\" methodology for interpreting these texts as sacred Scripture. Three successive historical case studies by Richard Steele vividly instantiate key themes of the Pastorals. This innovative yet reverent volume will help revive the interest of students, pastors, and other Christian leaders in the Pastoral Epistles.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0